export enum SectionDividerType {
    None = 0,
    Small = 1,
    Medium = 2,
    Large = 3,
    LineOnly = 4,
}
